import _ from 'lodash'

export default {
    name: 'Menu',
    data () {
        return {
            open: false,

        }
    },
    props: {
        model: {
            type: Object
        },
        bus: {
            type: Object,
            required: true,
        },
        root: {
            type: [Number, String],
            default: null,
        },
        value: {
            type: [Number, String],
            default: null,
        },
        search: {
            type: String,
            default: '',
        },
        level: {
            type: Number,
            default: 0,
        }
    },
    created() {
        this.updateTree()
    },
    computed: {
        hasChildren() {
            return this.model.children && this.model.children.length
        },
        active() {
            return this.model.root == this.root && this.model.value == this.value
        },
        found() {
            return this.isContains(this.search, this.model.name)
        }
    },
    watch: {
        search() {
            this.updateTree()
        },
        value() {
            this.updateTree()
        }
    },
    methods: {
        toggle() {
            this.open = ! this.open
            this.bus.$emit('update')
        },
        select() {
            if (this.model.value !== null)
                this.bus.$emit('select', {
                    value: this.model.value,
                    root: this.model.root
                })
            else
                this.toggle()
        },
        findByCriteria(model, criteria) {
            let i,
                currentChild,
                result

            if (criteria(model)) {
                return model
            } else {
                if (model.children)
                    for (i = 0; i < model.children.length; i++) {
                        currentChild = model.children[i]

                        result = this.findByCriteria(currentChild, criteria)

                        if (result !== false) {
                            return result
                        }
                    }

                return false;
            }
        },
        updateTree() {
            if (this.search && this.search.length) {
                this.open = !! this.findByCriteria(this.model, model => {
                    return model.children.some(item => { return this.isContains(this.search, item.name) })
                })
            } else {
                if (this.model.root == this.root) {
                    this.open = this.findByCriteria(this.model, model => {
                        return model.children.some(item => { return item.value == this.value })
                    }) || this.open
                }
            }
        },
        isContains(keyword, string) {
            return keyword.length && string.toLowerCase().indexOf(keyword.toLowerCase()) > -1
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/tree/tree-item.js